@if (!isCollapsed()) {
  <!-- Expanded view -->
  <div class="domain-picker domain-picker--expanded">
    <span class="domain-picker__label">{{ 'navigation.domainPicker.label.domain' | transloco }}</span>

    <p-select
      class="domain-picker__p-select"
      [options]="visibleDomains()"
      [(ngModel)]="selectedDomainItem"
      (ngModelChange)="onPSelectChange($event)"
      optionLabel="title"
      [filter]="true"
      [filterBy]="'title,url,searchKeywords'"

      (onFilter)="onFilterChange($event)"
      [filterPlaceholder]="'navigation.domainPicker.search.placeholder' | transloco"
      [placeholder]="'navigation.domainPicker.dropdown.placeholder' | transloco"
      [virtualScroll]="true"
      [virtualScrollItemSize]="38"
      [showClear]="false"
      styleClass="domain-picker__p-select"
      appendTo="self"
      [ariaLabel]="'navigation.domainPicker.select.ariaLabel' | transloco"
    >
      <ng-template #selectedItem let-item>
        <div class="domain-picker__selected-item">
          <span class="domain-picker__selected-label">
            @if (item?.type === DomainPickerValueType.DomainGroup) {
              <span class="domain-picker__item-domain-group-title">{{ getDomainTitleForGroup(item) }}</span>
              <span class="domain-picker__item-separator"> > </span>
              <span class="domain-picker__item-title">{{ item?.title }}</span>
            } @else {
              <span class="domain-picker__item-title">{{ item?.title }}</span>
            }
          </span>
        </div>
      </ng-template>

      <ng-template #item let-item>
        <div class="domain-picker__option"
          [class.domain-picker__option--group]="item.type === DomainPickerValueType.DomainGroup"
          [class.domain-picker__option--active]="item.id === selectedDomainId()"
          [class.domain-picker__option--disabled]="!hasDomainAccess(item)">
          @if (isFavouriteDomain(item)) {
            <span class="material-icons-outlined domain-picker__item-favourite-icon" aria-hidden="true">favorite</span>
          } @else {
            @if (item.type === DomainPickerValueType.DomainGroup) {
              <i class="pi pi-clone domain-picker__item-icon" aria-hidden="true"></i>
            } @else {
              <span class="domain-picker__item-icon" aria-hidden="true"></span>
            }
          }
          <span class="domain-picker__item-title">{{ item.title }}</span>
          @if (item.type === DomainPickerValueType.Domain && item.url) {
            <a
              class="domain-picker__item-link"
              [href]="item.url"
              target="_blank"
              rel="noopener noreferrer"
              (click)="$event.stopPropagation()"
              [title]="item.url"
              [attr.aria-label]="('navigation.domainPicker.openUrl.ariaLabel' | transloco) + ' ' + item.title"
            >
              <span class="material-icons-outlined" aria-hidden="true">open_in_new</span>
            </a>
          }
        </div>
      </ng-template>
    </p-select>
  </div>
} @else {
  <!-- Collapsed view: icon button triggers fixed-position popup with p-select -->
  <div class="domain-picker domain-picker--collapsed">
    <button
      class="domain-picker__icon-btn"
      type="button"
      [attr.aria-label]="currentDomain()?.title ?? currentDomainGroup()?.title ?? ('navigation.domainPicker.button.ariaLabel' | transloco)"
      [attr.aria-expanded]="isDropdownOpen()"
      aria-haspopup="dialog"
      [title]="currentDomain()?.title ?? currentDomainGroup()?.title ?? ('navigation.domainPicker.button.title' | transloco)"
      (click)="toggleDropdown($event, iconTriggerEl)"
      #iconTriggerEl
    >
      <span class="material-icons-outlined" aria-hidden="true">keyboard_arrow_down</span>
    </button>

    @if (isDropdownOpen()) {
      <div
        class="domain-picker__collapsed-popup"
        pFocusTrap
        [attr.aria-label]="'navigation.domainPicker.popup.ariaLabel' | transloco"
        [style.top.px]="popupPosition().top"
        [style.left.px]="popupPosition().left"
        [style.width.px]="popupWidth()"
      >
        <div class="domain-picker__collapsed-popup-content">
          <span class="domain-picker__label">{{ 'navigation.domainPicker.label.domain' | transloco }}</span>
          <p-select
            class="domain-picker__p-select"
            [options]="visibleDomains()"
            [(ngModel)]="selectedDomainItem"
            (ngModelChange)="onPSelectChange($event)"
            optionLabel="title"
            [filter]="true"
            [filterBy]="'title,url,searchKeywords'"
       
            (onFilter)="onFilterChange($event)"
            [filterPlaceholder]="'navigation.domainPicker.search.placeholder' | transloco"
            [placeholder]="'navigation.domainPicker.dropdown.placeholder' | transloco"
            [showClear]="false"
            styleClass="domain-picker__p-select"
            [virtualScroll]="true"
            [virtualScrollItemSize]="38"
            appendTo="self"
            [ariaLabel]="'navigation.domainPicker.select.ariaLabel' | transloco"
          >
            <ng-template #selectedItem let-item>
              <div class="domain-picker__selected-item">
                @if (item?.type === DomainPickerValueType.DomainGroup) {
                  <i class="pi pi-clone domain-picker__item-icon" aria-hidden="true"></i>
                } @else {
                  <span class="domain-picker__item-icon" aria-hidden="true"></span>
                }
                <span class="domain-picker__selected-label">
                  @if (item?.type === DomainPickerValueType.DomainGroup) {
                    <span class="domain-picker__item-domain-group-title">{{ getDomainTitleForGroup(item) }}</span>
                    <span class="domain-picker__item-separator"> > </span>
                    <span class="domain-picker__item-title">{{ item?.title }}</span>
                  } @else {
                    <span class="domain-picker__item-title">{{ item?.title }}</span>
                  }
                </span>
              </div>
            </ng-template>

            <ng-template #item let-item>
              <div class="domain-picker__option"
                [class.domain-picker__option--group]="item.type === DomainPickerValueType.DomainGroup"
                [class.domain-picker__option--active]="item.id === selectedDomainId()"
                [class.domain-picker__option--disabled]="!hasDomainAccess(item)">
                @if (isFavouriteDomain(item)) {
                  <span class="material-icons-outlined domain-picker__item-favourite-icon" aria-hidden="true">favorite</span>
                } @else {
                  @if (item.type === DomainPickerValueType.DomainGroup) {
                    <i class="pi pi-clone domain-picker__item-icon" aria-hidden="true"></i>
                  } @else {
                    <span class="domain-picker__item-icon" aria-hidden="true"></span>
                  }
                }
                <span class="domain-picker__item-title">{{ item.title }}</span>
                @if (item.type === DomainPickerValueType.Domain && item.url) {
                  <a
                    class="domain-picker__item-link"
                    [href]="item.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="$event.stopPropagation()"
                    [title]="item.url"
                    [attr.aria-label]="('navigation.domainPicker.openUrl.ariaLabel' | transloco) + ' ' + item.title"
                  >
                    <span class="material-icons-outlined" aria-hidden="true">open_in_new</span>
                  </a>
                }
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
    }
  </div>
  <div class="domain-picker__divider"></div>
}
